import { DashboardShell } from "./DashboardShell";
import { MetricCard } from "./MetricCard";
import { ChartCard } from "./ChartCard";
import { ActivityPanel } from "./ActivityPanel";
import { healthcarePreview } from "@/data/dashboardPreview.data";
import { DashboardContent } from "./DashboardContent";

interface Props {
    accent: string;
}

export function HealthcareDashboard({
    accent,
}: Props) {
    const preview = healthcarePreview;

    return (
        <DashboardShell
            accent={accent}
            title="Hospital Management System"
            subtitle="Live hospital operations dashboard"
            sidebar={[
                "Dashboard",
                "Patients",
                "Appointments",
                "Doctors",
                "Laboratory",
                "Pharmacy",
                "Billing",
                "Reports",
            ]}
        >
            <DashboardContent

                accent={accent}

                preview={healthcarePreview}

                activityTitle="Clinical Activity"

            />

            {/* <div className="grid gap-6"> */}

                {/* ==========================================================
                   Top KPI Cards
                =========================================================== */}

                {/* <div className="grid gap-5 md:grid-cols-4">

                    {
                        preview.metrics.map((metric) => (

                            <MetricCard
                                key={metric.label}
                                accent={accent}
                                label={metric.label}
                                value={metric.value}
                                trend={metric.trend}
                            />

                        ))
                    }

                </div> */}

                {/* ==========================================================
                   Main Chart + Activity
                =========================================================== */}

                {/* <div className="grid gap-6 lg:grid-cols-[2fr_1fr]">

                    <ChartCard
                        accent={accent}
                        title={preview.chart.title}
                        values={preview.chart.values}
                    />

                    <ActivityPanel
                        accent={accent}
                        title="Clinical Activity"
                        items={preview.activities ?? []}
                    />

                </div> */}
                {/* ==========================================================
                   Operations
                =========================================================== */}

                {/* <div className="grid gap-6 lg:grid-cols-3">

                    <div className="rounded-2xl border border-border bg-card p-5">

                        <h3 className="text-sm font-semibold">
                            Bed Occupancy
                        </h3>

                        <div className="mt-5 space-y-5">

                            {[
                                {
                                    ward: "General Ward",
                                    value: 82,
                                },
                                {
                                    ward: "ICU",
                                    value: 94,
                                },
                                {
                                    ward: "Emergency",
                                    value: 76,
                                },
                                {
                                    ward: "Pediatrics",
                                    value: 58,
                                },
                            ].map((row) => (
                                <div key={row.ward}>

                                    <div className="flex justify-between text-sm">

                                        <span>
                                            {row.ward}
                                        </span>

                                        <span>
                                            {row.value}%
                                        </span>

                                    </div>

                                    <div className="mt-2 h-2 rounded-full bg-muted">

                                        <div
                                            className="h-full rounded-full"
                                            style={{
                                                width: `${row.value}%`,
                                                background: accent,
                                            }}
                                        />

                                    </div>

                                </div>
                            ))}

                        </div>

                    </div>
                    <div className="rounded-2xl border border-border bg-card p-5">

                        <h3 className="text-sm font-semibold">
                            Laboratory Queue
                        </h3>

                        <div className="mt-5 space-y-4">

                            {[
                                {
                                    test: "Blood Test",
                                    pending: 24,
                                },
                                {
                                    test: "MRI Scan",
                                    pending: 8,
                                },
                                {
                                    test: "CT Scan",
                                    pending: 5,
                                },
                                {
                                    test: "Ultrasound",
                                    pending: 12,
                                },
                            ].map((row) => (
                                <div
                                    key={row.test}
                                    className="flex items-center justify-between rounded-xl border border-border px-4 py-3"
                                >

                                    <div>

                                        <p className="font-medium">
                                            {row.test}
                                        </p>

                                        <p className="text-xs text-muted-foreground">
                                            Pending Reports
                                        </p>

                                    </div>

                                    <span
                                        className="rounded-full px-3 py-1 text-xs font-semibold"
                                        style={{
                                            background: `${accent}15`,
                                            color: accent,
                                        }}
                                    >
                                        {row.pending}
                                    </span>

                                </div>
                            ))}

                        </div>

                    </div>
                    <div className="rounded-2xl border border-border bg-card p-5">

                        <h3 className="text-sm font-semibold">
                            Critical Alerts
                        </h3>

                        <div className="mt-5 space-y-4">

                            {[
                                "ICU Bed Capacity Near Full",
                                "Blood Bank Inventory Low",
                                "MRI Machine Maintenance Due",
                                "Emergency Room High Patient Load",
                            ].map((alert) => (
                                <div
                                    key={alert}
                                    className="rounded-xl border border-red-200 bg-red-50 px-4 py-3"
                                >

                                    <p className="text-sm font-medium text-red-700">
                                        {alert}
                                    </p>

                                </div>
                            ))}

                        </div>

                    </div>

                </div> */}
                {/* ==========================================================
                   Clinical KPIs
                =========================================================== */}

                {/* <div className="grid gap-5 md:grid-cols-4">

                    <MetricCard
                        accent={accent}
                        label="Average Waiting Time"
                        value="11 min"
                        trend="-18%"
                    />

                    <MetricCard
                        accent={accent}
                        label="Patient Satisfaction"
                        value="96%"
                        trend="+5%"
                    />

                    <MetricCard
                        accent={accent}
                        label="Successful Surgeries"
                        value="99.1%"
                        trend="+1%"
                    />

                    <MetricCard
                        accent={accent}
                        label="Laboratory SLA"
                        value="98.6%"
                        trend="+2%"
                    />

                </div> */}

            {/* </div> */}

        </DashboardShell>
    );
}